import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const EDIT_TASK_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: true,
  width: "1200px",
  height: "850px",
};
